module.exports = __webpack_public_path__ + "static/img/178_TO8_2020.f7d6453.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/178_TO8_2020.jpg
// module id = VZ1L
// module chunks = 0